import { p as proxyCustomElement, H, h, d as Host } from './p-bfa0dc67.js';
import { c as classNames } from './p-df8c8ec2.js';
import { g as getSize } from './p-637123cf.js';

const biTypographyCss = ".sr-only{position:absolute;height:1px;width:1px;padding:0;margin:-1px;overflow:hidden;border:0;left:-9999px;text-indent:-5000px;clip:rect(1px, 1px, 1px, 1px);}*,*:before,*:after{box-sizing:border-box}html,body,div,span,object,iframe,figure,h1,h2,h3,h4,h5,h6,p,blockquote,pre,a,code,em,img,small,strike,strong,sub,sup,tt,b,u,i,ol,ul,li,fieldset,form,label,table,caption,tbody,tfoot,thead,tr,th,td,main,canvas,embed,footer,header,nav,section,button,video{margin:0;padding:0;border:0;font-size:100%;font:inherit;vertical-align:baseline;text-rendering:optimizeLegibility;-webkit-font-smoothing:antialiased;text-size-adjust:none}footer,header,nav,section,main{display:block}body{line-height:1.5}ol,ul{list-style:none}blockquote,q{quotes:none}blockquote:before,blockquote:after,q:before,q:after{content:\"\";content:none}table{border-collapse:collapse;border-spacing:0}input{-webkit-appearance:none;appearance:none;border-radius:0}:host(:focus){outline:none !important;border:none !important}:host(.light){color:white}:host(.slab)>*{font-family:\"museo-slab\", serif}:host(.bold){font-weight:700}:host(.regular){font-weight:500}:host(.thin){font-weight:300}:host(.small){font-size:0.75rem;line-height:1.5}:host(.medium){font-size:1rem;line-height:1.5}:host(.large){font-size:1.25rem;line-height:1.5}:host(.xl){font-size:1.5rem;line-height:1.5}:host(.xxl){font-size:2rem;line-height:1.5}:host(.x4xl){font-size:2.5rem;line-height:1.5}:host(.x8xl){font-size:3rem;line-height:1.5}:host(.highlight){color:#ffde8c}:host(.dark.highlight){color:#01417b}:host(.body){color:whitesmoke}:host(.dark.body){color:#414651}:host(.disabled){color:#717680}:host(.dark.disabled){color:#717680}:host(.link){color:#78c2ff}:host(.dark.link){color:#0b62c5}:host(.subtle){color:#e9eaeb}:host(.dark.subtle){color:#717680}";
const BiTypographyStyle0 = biTypographyCss;

const BiTypography = /*@__PURE__*/ proxyCustomElement(class BiTypography extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.fontStyle = 'regular';
        this.fontSize = 'medium';
        this.fontColor = 'body';
        this.font = 'sans';
        // eslint-disable-next-line @stencil-community/ban-default-true
        this.dark = true;
    }
    render() {
        return (h(Host, { key: '5374070e0ad87bb6aa36b44c2da8fd9a8788f526', class: classNames(getSize(this.fontSize), this.fontStyle, { dark: this.dark }, this.fontColor, this.font) }, h("slot", { key: 'b2c736cf5bc35f0574e861f9ac94a24b0af39e51' })));
    }
    static get style() { return BiTypographyStyle0; }
}, [1, "bi-typography", {
        "fontStyle": [1, "font-style"],
        "fontSize": [1, "font-size"],
        "fontColor": [1, "font-color"],
        "font": [1],
        "dark": [4]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["bi-typography"];
    components.forEach(tagName => { switch (tagName) {
        case "bi-typography":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, BiTypography);
            }
            break;
    } });
}

export { BiTypography as B, defineCustomElement as d };
